import { PhosphorWarning } from "components/Atoms/PhosphorIcon";
import React from "react";

export const DeletedRow = () => {
  return <>
    <div className="flex">
      <div className="margin-right">
        <PhosphorWarning iconSize="large" />
      </div>
      <div>
        <div>{RESX.File.Deleted}</div>
      </div>
    </div>
  </>;
}